<ul class="point-list" [class.show--minimal-dots-first]="showMinimalDotsFirst()">
  @for (point of points(); track point.id) {
    <li
      class="point-list__item"
      [style.left.%]="point.coordinates.x"
      [style.top.%]="point.coordinates.y"
      [attr.data-order]="point.order"
      [class.is--active]="lastHoveredPointId === point.id"
    >
      <!-- (mouseleave)="lastHoveredPointId = null" -->
      <button
        class="point"
        (mouseenter)="openOverlay($event, point)"
        (click)="openOverlay($event, point, true)"
        cdkOverlayOrigin
        #origin="cdkOverlayOrigin"
      >
        <span class="sr-only">{{ $index }}</span>
      </button>

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="origin"
        [cdkConnectedOverlayOpen]="lastHoveredPointId === point.id"
        [cdkConnectedOverlayPositions]="overlayPositions"
        [cdkConnectedOverlayPush]="true"
        [cdkConnectedOverlayViewportMargin]="16"
        [cdkConnectedOverlayFlexibleDimensions]="true"
        cdkConnectedOverlayPanelClass="media-point-map-overlay"
        (detached)="closeOverlay()"
      >
        <app-product-link-card
          class="hover-card"
          animate.leave="hover-card-leave"
          [productPreview]="point"
          (mouseenter)="cancelClose()"
          (mouseleave)="scheduleClose()"
        ></app-product-link-card>
      </ng-template>
    </li>
  }
</ul>
